<template>

    <div class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <h1 class="title is-3">Seite wurde nicht gefunden</h1>
                <p>Die Seite konnte nicht gefunden werden, bitte überprüfen Sie Ihre Eingaben!<br /> [ <a href="/" @click.prevent="goHome">zurück</a> ]</p>
            </div>
        </div>
    </div>

</template>


<script>
export default {
  methods: {
    goHome() {
      this.$router.go(-1);
    }
  }
}
</script>
